module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/hash_icon_wh-4e90f83f3df7d4a99f7acb7b5b70d4fd.png";